// Texty konce akční ceny (saleEnd.js): datum konce a odpočet ve třech hustotách.
import { plural } from '../plural.js';

export default {
  until: 'do',
  untilLong: 'Akční cena platí do',
  endsCard: 'za',
  ends: 'končí za',
  endsLong: 'Akce končí za',
  /** genitiv dnů v týdnu („do soboty 5. 9."), index = Date#getDay() */
  weekdayGenitive: ['neděle', 'pondělí', 'úterý', 'středy', 'čtvrtka', 'pátku', 'soboty'],
  /** krátké jednotky odpočtu („2 d 5 h", „42 min") */
  dayShort: 'd',
  hourShort: 'h',
  minShort: 'min',
  /** dlouhé tvary po „za" (akuzativ) */
  days: (n) => plural(n, ['den', 'dny', 'dnů']),
  hours: (n) => plural(n, ['hodinu', 'hodiny', 'hodin']),
  minutes: (n) => plural(n, ['minutu', 'minuty', 'minut']),
};
